import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { TabelaPrecoFormModel } from 'model/app/forms/tabela-preco/tabela-preco-form-model';
import { VariaveisAmbiente } from 'config';

export function usePutAtualizarTabelaPreco() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAtualizarTabelaPreco = useCallback(
        (tabelaPreco: TabelaPrecoFormModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/tabelapreco`,
                data: tabelaPreco,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putAtualizarTabelaPreco,
    };
}
